import { omitBy } from 'lodash';
import { isEmptyString } from '@common/utils/helpers/object/is-nil-or-empty-string';

export const getObjectWithoutNilOrEmptyStringValues = (object: object) => {
  return omitBy(object, isEmptyString);
};
